import { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [action, setAction] = useState("");

  const load = async () => { const { data } = await api.get("/audit-logs", { params: action ? { action } : {} }); setRows(data); };
  useEffect(() => { load(); }, [action]); // eslint-disable-line

  const actions = [...new Set(rows.map((r) => r.action))];

  return (
    <div>
      <PageHeader title="Audit Logs" subtitle={`${rows.length} event(s)`} />
      <div className="p-6 lg:p-8 space-y-4">
        <select className="input max-w-xs" value={action} onChange={(e) => setAction(e.target.value)} data-testid="audit-action-filter">
          <option value="">All Actions</option>
          {["Login Success", "Login Failed", "OTP Sent", "OTP Verified", "OTP Failed", "Logout", "Password Changed", "OA Created", "OA Edited", "OA Deleted", "OA Duplicated", "OA Number Changed", "OA Number Settings Changed", "Company Settings Changed", "Customer Changed", "Product Changed", "Employee Created", "Employee Disabled"].map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 border-b border-slate-200"><tr>
                <th className="th">Date</th><th className="th">Time</th><th className="th">User</th><th className="th">Role</th><th className="th">Action</th><th className="th">OA No.</th><th className="th">Old</th><th className="th">New</th>
              </tr></thead>
              <tbody className="divide-y divide-slate-100">
                {rows.length === 0 && <tr><td className="td text-slate-400" colSpan={8}>No audit events.</td></tr>}
                {rows.map((r) => (
                  <tr key={r.id} className="hover:bg-slate-50" data-testid={`audit-row-${r.id}`}>
                    <td className="td">{r.date}</td>
                    <td className="td font-mono text-xs">{r.time}</td>
                    <td className="td">{r.userName || r.user}</td>
                    <td className="td capitalize">{r.role}</td>
                    <td className="td"><span className="badge bg-slate-100 text-slate-700 border border-slate-300">{r.action}</span></td>
                    <td className="td font-mono">{r.oaNumber || "—"}</td>
                    <td className="td text-xs text-slate-500 max-w-[180px] truncate">{r.oldValue || "—"}</td>
                    <td className="td text-xs text-slate-500 max-w-[180px] truncate">{r.newValue || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
